import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../config';
import parse from 'html-react-parser';
import classes from './Page.module.css';

const BackIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="#2c3030" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const Page = ({ setShowPage, id }) => {
  const [pageContent, setPageContent] = useState();

  useEffect(() => {
    setPageContent();
    if (!id) return;
    const getPage = async () => {
      const docRef = doc(db, 'pages', id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) setPageContent(docSnap.data());
    };
    getPage();
    return () => setPageContent();
  }, [id]);

  return ReactDOM.createPortal(
    <div className={classes.overlay}>
      <div className={classes.page}>
        <div className={classes.header}>
          <button className={classes.backBtn} onClick={() => setShowPage(false)} aria-label="Go back">
            <BackIcon />
          </button>
          <span className={classes.title}>{pageContent?.title ?? ''}</span>
        </div>
        <div className={classes.content}>
          {pageContent ? parse(pageContent.text || '') : <div className={classes.loading} />}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default Page;
